// extracted by mini-css-extract-plugin
module.exports = {"rooms":"rooms-module--rooms--1ACS4","bistromenu":"rooms-module--bistromenu--1HFqC","content":"rooms-module--content--2BLXw","list":"rooms-module--list--2M7jE"};